import { css } from "styled-components";
import { BladeHeaderTitle } from "../../../../components/BladeHeaderTitle";
import { BladeHeaderDecoration } from "../../../../components/BladeHeaderDecoration";
import { BladeHeaderBody } from "../../../../components/BladeHeaderBody";
import { riotProductSkin } from "../riot-product";
import { Icon } from "../../../../../Icon";
export const arcaneSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  ${BladeHeaderTitle} {
    h2 {
      ${chroma.typography.display3};
      text-transform: none;

      &::after {
        display: none;
      }
    }
  }

  ${BladeHeaderBody} {
    margin-top: 24px;
  }

  ${BladeHeaderDecoration} {
    height: 32px;
    display: flex;
    justify-content: start;
    flex-direction: column;
    margin-top: 24px;

    ${chroma.mediaQueries.tabletDown} {
      height: 24px;
      margin-top: 0;
    }

    ${chroma.mediaQueries.mobileDown} {
      height: 16px;
    }

    ${Icon} {
      height: 18px;

      ${chroma.mediaQueries.tabletDown} {
        height: 100%;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map